import React, { useState, useEffect} from 'react';

import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import InputSelect from '../../../Components/InputSelect';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

import { toast } from 'react-toastify';

const CreateAccount = () => {

    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);
    const userId ={userID: decodedToken.id};

    const countryNames = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Anguilla",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Ascension",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda Is",
        "Bolivia",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burma",
        "Burundi",
        "Cameroon",
        "Canada",
        "Cayman Is",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Congo",
        "Cook Is",
        "Costa Rica",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica Rep",
        "Ecuador",
        "Egypt",
        "EI Salvador",
        "Estonia",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guinea",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hongkong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Ivory Coast",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kampuchea (Cambodia)",
        "Kazakstan",
        "Kenya",
        "Korea",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mariana Is",
        "Martinique",
        "Mauritius",
        "Mexico",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montserrat Is",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netheriands Antilles",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "Norway",
        "Oman",
        "Pakistan",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Saint Lucia",
        "Saint Vincent",
        "Samoa Eastern",
        "Samoa Western",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Is",
        "Somalia",
        "South Africa",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States of America",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Yugoslavia",
        "Zimbabwe",
        "Zaire",
        "Zambia",
        "Montenegro "
    ];

    const date = new Date();

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    const [agentData, setAgentData] = useState({
        userId:userId.userID,
        name:'',
        account:'',
        password:'',
        contacts:'',
        area:'',
        detailed_address:'',
        ptt_card:'',
        gps_card:'',
        sos_card:'',
        bounding_card:'',
        recording_card:'',
        duplex_card:'',
        vip_card:'',
        creation_date:formattedDate,

    });

    const handleAgentChange = (e) => {
        setAgentData({
            ...agentData,
            [e.target.name]: e.target.value,
        });
    };
    const handleDataFromChild = (data) => {
        setAgentData({
            ...agentData,
            ['area']: data,
        });
    };

    const regex1 = /^(?!_)[a-zA-Z0-9_]{4,20}$/;//4-20 characters, includes letters, numbers, underscores, and does not start with an underscore.
    const regex2 = /^(?!_)[a-zA-Z0-9_]{6,20}$/;//Contains 6-20 numbers, letters, underlines, but not starts with underline
    const regex3 = /^[a-zA-Z0-9]{6,16}$/;//contains 6-16 digits of letters and numbers
    const regex4 = /^(?!_)[a-zA-Z0-9_]{2,10}$/;//Contains 2-10 numbers, letters, underlines, but not starts with underline
    const [error, setError] = useState("");
    const handleAgentCreate = async(e) => {
        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            if (regex1.test(agentData.name)) {
                setError("");
              } else {
                toast.warn("Agent name contains 4-20 numbers, letters, underlines, but not starts with underline", {
                    className: 'centered-toast1',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
              }
            if (regex2.test(agentData.account)) {
                setError("");
              } else {
                toast.warn("Account contains 6-20 numbers, letters, underlines, but not starts with underline", {
                    className: 'centered-toast1',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
              }
            if (regex3.test(agentData.password)) {
                setError("");
              } else {
                toast.warn("Password contains 6-16 digits of letters and numbers", {
                    className: 'centered-toast2',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
              }
            if (regex4.test(agentData.contacts)) {
                setError("");
              } else {
                toast.warn("Contact person should contain 2-10 numbers, letters, underlines, but not start with underline", {
                    className: 'centered-toast3',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }
            if (regex4.test(agentData.area)) {
                setError("");
              } else {
                toast.warn("area cannot be empty", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            const response = await axios.post(`${POCBaseUrl}/agents/create`, {agentData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                console.log(response.data.message);
                toast.success("Created successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };
    
    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]" style={{ fontFamily: 'Liberation Serif' }}>
                <div className="ml-[25px] mt-2.5 pr-[40px]">
                    <form className='m-0 p-0'>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Name'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'name'} value={agentData.name || ''} onChange={handleAgentChange} placeholder={'Please enter agent name'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 4-20 numbers, letters, underlines, but not starts with underline</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Account'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'account'} value={agentData.account || ''} onChange={handleAgentChange} placeholder={'Please input account'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 6-20 numbers, letters, underlines, but not starts with underline</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Password'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'password'} value={agentData.password || ''} onChange={handleAgentChange} type={'password'} placeholder={'Please input the login password'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>contains 6-16 digits of letters and numbers</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Contacts'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'contacts'} value={agentData.contacts || ''} onChange={handleAgentChange} placeholder={'Please input contact person'} />
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 2-10 numbers, letters, underlines, but not starts with underline</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Area'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputSelect name={'area'} value={agentData.area || ''} onSendData={handleDataFromChild} options={countryNames} placeholder={'Please select area'} inputwidth={360}/>
                            </div>
                            <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Please select area</span>
                        </div>
                        <div className='mb-[22px] flex'>
                            <div className='w-[150px]'>
                                <Label text={'Detailed address'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <InputField name = {'detailed_address'} value={agentData.detailed_address || ''} onChange={handleAgentChange} placeholder={'Please enter detailed address'} />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className='mt-2.5 bg-[#f0f0f0]'>
                <button onClick={handleAgentCreate} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2.5 px-24 rounded text-white cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>
                    Save
                </button>
            </div>
        </>
    );
}

export default CreateAccount;